import { GetWorkAreaDocument, GetWorkAreaQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkAreaNodes = GetWorkAreaQuery['locations']['workArea']
export const useWorkArea = ({ id }: { id: number }) => {
  const { loading, data } = useQuery(GetWorkAreaDocument, { variables: { id } })

  return {
    loading,
    workArea: data && data.locations.workArea,
  }
}
